export default {
    newest: 'Neueste',
    oldest: 'Letzte',
    noEntries: 'Keine Einträge gefunden',

    general: {
        organisationNews:  'Neuigkeiten'
    },

    processes: {
        title: 'Maßnahmen in "Gestartet"',
        tableIndex: 'Übersicht Maßnahmen in "Gestartet"'
    },

    paymentRuns: {
        title: 'Letzte Zahlungsläufe',
        tableIndex: 'Übersicht letzte Zahlungsläufe',
        id: 'Zahlungslauf #',
    },
}